import { useState } from 'react'
import { UserDTO } from '~/domain/user/dto/UserDTO'

export interface Props {
  user: UserDTO
  canSponsorRequest: boolean
  onRequest?: () => void
}

export const useSponsorRequestButton = (props: Props) => {
  const [isOpenModal, setIsOpenModal] = useState(false)
  const { user, onRequest, canSponsorRequest } = props
  const onClick = () => {
    setIsOpenModal(true)
  }
  const onCloseModal = () => {
    // if (onRequest) {
    //   onRequest()
    // }

    setIsOpenModal(false)
  }

  return {
    user,
    isOpenModal,
    canSponsorRequest,
    onClick,
    onCloseModal,
  }
}
